import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";
import {
  QUERY_V2_PROTOCOL_DATA,
  SUBSCRIBE_V2_PROTOCOL_DATA,
  QUERY_V2_CONNECTED_STATE,
  SUBSCRIBE_V2_CONNECTED_STATE,
  MUTATE_CONNECT_V2_PROTOCOL,
  MUTATE_DISCONNECT_V2_PROTOCOL,
  MUTATE_CONNECT_TO_V2_PROTOCOL_RECEIVER,
  MUTATE_DISCONNECT_FROM_V2_PROTOCOL_RECEIVER,
  MUTATE_SET_V2_MODE,
} from "../queries/aksQueries";

import { combineV2Data, setV2ConnectedState } from "../../../state/aksReducer";

import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

export function QueryV2ProtocolData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_V2_PROTOCOL_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(combineV2Data(data.getV2ProtocolData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeV2ProtocolData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_V2_PROTOCOL_DATA, {
    onData: (x) => {
      dispatch(combineV2Data(x.data.data.newV2ProtocolData));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function QueryV2Connection() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_V2_CONNECTED_STATE);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setV2ConnectedState(data.getV2ConnectedState));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeV2Connection() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_V2_CONNECTED_STATE, {
    onData: (x) => {
      dispatch(setV2ConnectedState(x.data.data.newV2ConnectedState));
      if (x.data.data.newV2ConnectedState.connected === true) {
        if (x.data.data.newV2ConnectedState.connectionType === "direct") {
          if (x.data.data.newV2ConnectedState.directConnectionParams?.host) {
            toast(
              `Connected to V2 Protocol at ${x.data.data.newV2ConnectedState.directConnectionParams.host}`,
              { icon: "🤝" },
            );
          }
        } else if (
          x.data.data.newV2ConnectedState.connectionType === "receiver"
        ) {
          toast(
            `Connected to V2 Protocol via ${x.data.data.newV2ConnectedState.activeReceiver} Receiver`,
            { icon: "📡" },
          );
        }
      } else if (x.data.data.newV2ConnectedState.connected === false) {
        dispatch(combineV2Data({ timing: "NULL" }));
      }
    },
  });
  if (error) {
    console.log(error);
  }
}

export function MutateConnectToV2Protocol() {
  const [connectToV2Protocol] = useMutation(MUTATE_CONNECT_V2_PROTOCOL);
  return connectToV2Protocol;
}

export function MutateDisconnectFromV2Protocol() {
  const [disconnectFromV2Protocol] = useMutation(MUTATE_DISCONNECT_V2_PROTOCOL);
  return disconnectFromV2Protocol;
}

export function MutateConnectToV2ProtocolReceiver() {
  const [connectToV2ProtocolReceiver] = useMutation(
    MUTATE_CONNECT_TO_V2_PROTOCOL_RECEIVER,
  );
  return connectToV2ProtocolReceiver;
}

export function MutateDisconnectFromV2ProtocolReceiver() {
  const [disconnectFromV2ProtocolReceiver] = useMutation(
    MUTATE_DISCONNECT_FROM_V2_PROTOCOL_RECEIVER,
  );
  return disconnectFromV2ProtocolReceiver;
}

export function MutateSetV2Mode() {
  const [setV2Mode] = useMutation(MUTATE_SET_V2_MODE);
  return setV2Mode;
}
